import {
  Wrapper
} from './styles'

interface Props {
  value: number;
}

export default function Counter({ value }: Props) {
  return (
    <Wrapper>
      {value > 9 ? `9+` : value}
    </Wrapper>
  );
}